export default function HandoffModeToggle({
  handoffMode,
  onHandoffModeChange,
  onSelfDropSelected,
  nearestCenter,
  nearestCenterLoading,
  testIdPrefix = "handoff",
  radioGroupName = "handoff_mode",
  accentColorClass = "accent-indigo-600",
}) {
  return (
    <div>
      <label className="text-xs font-medium text-slate-600 block mb-1.5">How will this reach Delhivery?</label>
      <div className="flex gap-4 mb-2">
        <label className="flex items-center gap-1.5 cursor-pointer">
          <input
            type="radio"
            name={radioGroupName}
            checked={handoffMode === "FM_PICKUP"}
            onChange={() => onHandoffModeChange("FM_PICKUP")}
            className={accentColorClass}
            data-testid={`${testIdPrefix}-fm-pickup`}
          />
          <span className="text-sm text-slate-700">FM Pickup</span>
        </label>
        <label className="flex items-center gap-1.5 cursor-pointer">
          <input
            type="radio"
            name={radioGroupName}
            checked={handoffMode === "SELF_DROP"}
            onChange={() => { onHandoffModeChange("SELF_DROP"); onSelfDropSelected(); }}
            className={accentColorClass}
            data-testid={`${testIdPrefix}-self-drop`}
          />
          <span className="text-sm text-slate-700">Self-Drop</span>
        </label>
      </div>
      {handoffMode === "SELF_DROP" && (
        <div className="text-xs bg-amber-50 border border-amber-200 rounded px-3 py-2">
          {nearestCenterLoading ? (
            <span className="text-amber-700">Looking up nearest Delhivery hub…</span>
          ) : nearestCenter?.error ? (
            <span className="text-red-600">Could not look up nearest hub — check with Delhivery directly.</span>
          ) : nearestCenter ? (
            <div className="text-amber-800">
              <div><strong>Drop at:</strong> {nearestCenter.center_name || "Unknown center"} ({nearestCenter.city}, {nearestCenter.state})</div>
              {nearestCenter.cached_address ? (
                <div className="mt-1">{nearestCenter.cached_address}</div>
              ) : (
                <div className="mt-1 italic">Address not yet on file — confirm with Delhivery before dispatching.</div>
              )}
            </div>
          ) : null}
        </div>
      )}
    </div>
  );
}
